<script setup lang="ts">
/**
 * One group of an office ribbon's command body: the commands on top, the
 * group's name below them („Zwischenablage“, „Schriftart“), a divider to the
 * next group.
 *
 * `layout="row"` (default) lines the commands up side by side — a row of large
 * commands, or large and small mixed. `layout="rows"` stacks `NxRibbonRow`s
 * („Schriftart“: the font fields on top, the format toggles below) and lets
 * them share a left edge. The group sizes to its content; a host may give it a
 * width (flex basis, min-width) for a group that has to give way, and `fill`
 * lets its content take that whole width (a gallery that shows fewer tiles
 * when the window gets narrow) instead of being centred in it.
 */
import '../office-ribbon.css';

export type NxRibbonGroupLayout = 'row' | 'rows';

const props = withDefaults(
  defineProps<{
    /** The group's name under its commands. */
    label: string;
    layout?: NxRibbonGroupLayout;
    /** The content takes the group's whole width, from its start edge. */
    fill?: boolean;
  }>(),
  { layout: 'row', fill: false }
);
</script>

<template>
  <section
    class="nx-ribbon-group"
    :class="[`nx-ribbon-group--${props.layout}`, { 'nx-ribbon-group--fill': props.fill }]"
  >
    <div class="nx-ribbon-group__body"><slot /></div>
    <span class="nx-ribbon-group__label">{{ props.label }}</span>
  </section>
</template>
